// extracted by mini-css-extract-plugin
export default {"cardInfoColored":"CardInfoColored_cardInfoColored__b+oDL","colored":"CardInfoColored_colored__UDVcz","value":"CardInfoColored_value__1ukc7"};